import { useStaticQuery, graphql } from "gatsby"

const supportFooterNavQuery = graphql`query SupportFooterNavQuery {
  allCraftSupportFooterNavNode(sort: {lft: ASC}, filter: {level: {eq: 1}}) {
    nodes {
      uid
      title
      nodeUri
      newWindow
      type
      element {
        ... on Craft_EntryInterface {
          uid
        }
      }
    }
  }
  allCraftCompanyFooterNavNode(sort: {lft: ASC}, filter: {level: {eq: 1}}) {
    nodes {
      uid
      title
      nodeUri
      newWindow
      type
      element {
        ... on Craft_EntryInterface {
          uid
        }
      }
    }
  }
}`

/**
 * Get Craft's supportFooterNav top level data
 */
export const useSupportFooterNav = () => {
  const { allCraftSupportFooterNavNode, allCraftCompanyFooterNavNode } =
    useStaticQuery(supportFooterNavQuery)

  return {
    supportNav: allCraftSupportFooterNavNode.nodes,
    companyNav: allCraftCompanyFooterNavNode.nodes,
  }
}
